let pkg = require("../../package.json")
let get = function(url){
    return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open("get", url, true);
        xhr.onload = function(){
            if(xhr.status == 200){
                resolve(JSON.parse(xhr.responseText));
            }
            else {
                reject(null);
            }
        };
        xhr.onerror = function(){
            reject(null);
        }
        xhr.send(null);
    });

};

export default {
    getConfig(fileName) {
        let hash = Math.random();
        if(process.env.NODE_ENV === 'production'){
            return get(`/${pkg.version}/${fileName}?streamNo=v${(new Date()).getTime() + parseInt(Math.random() * 1000000)}`);
        }else{
            return get(`/${fileName}?streamNo=v${(new Date()).getTime() + parseInt(Math.random() * 1000000)}`);
        }

    }
}
